<template>
  <div class="contact-box">
    <ContactDetails :contact="contact" :editable="editable" />
    <slot />
  </div>
</template>

<script>
import ContactDetails from '@/components/ContactDetails.vue';

export default {
  components: {
    ContactDetails,
  },
  props: {
    contact: {
      type: Object,
      required: true,
    },
    editable: {
      default: false,
      type: Boolean,
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../styles/vars/callouts';

.contact-box {
  background-color: $callout-primary-background;
  border: 1px solid $callout-primary-border;
  border-radius: 5px;
  font-size: 1.12rem;
  padding: 18px;
  margin: 8px 0px;
}
</style>
